/**
 * Socket.IO event names for real-time notifications
 */
export var SocketIOEvents = {
    ChatNew: 'chat:new',
    MessageNew: 'message:new',
    ChatUpdate: 'chat:update',
    ChatSubscribe: 'chat:subscribe',
    ChatUnsubscribe: 'chat:unsubscribe'
};
/**
 * Socket.IO configuration constants
 */
export var SocketIOConfig = {
    Path: '/socket.io',
    UserRoomPrefix: 'user:',
    DefaultUserId: 'guest'
};
//# sourceMappingURL=socket.js.map